export interface AddRelatedPartPayload {
  readonly jobId: number;
  readonly identifiers: string[];
}

export interface AddRelatedPartResponse {
  readonly status: string;
  readonly memopad?: string;
  readonly detail?: unknown;
}

export function appendConfirmedIdentifier(
  identifiers: readonly string[],
  identifier: string,
): readonly string[] {
  return identifiers.includes(identifier) ? identifiers : [...identifiers, identifier];
}

export function displayConfirmedIdentifiersNewestFirst(
  identifiers: readonly string[],
): readonly string[] {
  return [...identifiers].reverse();
}

export function createAddRelatedPartPayload(
  jobId: number,
  identifiers: readonly string[],
): AddRelatedPartPayload {
  return { jobId, identifiers: [...identifiers] };
}

export class RelatedPartRegistrationRequest {
  private inFlight?: Promise<AddRelatedPartResponse>;

  submit(
    payload: AddRelatedPartPayload,
    request: (payload: AddRelatedPartPayload) => Promise<AddRelatedPartResponse>,
  ): Promise<AddRelatedPartResponse> {
    if (this.inFlight) {
      return this.inFlight;
    }

    const requestPromise = Promise.resolve().then(() => request(payload));
    const trackedPromise = requestPromise.finally(() => {
      if (this.inFlight === trackedPromise) {
        this.inFlight = undefined;
      }
    });
    this.inFlight = trackedPromise;
    return trackedPromise;
  }
}
